import PropTypes from 'prop-types';
import React from 'react';

import { AdminPage } from '../lib/admin_layout';
import connect from 'components/lib/connect';
import IntegrationsNav from 'components/admin/integrations/integrations_nav';
import WebhooksList from './webhooks_list';

export function WebhooksAdminPage({ isEnabled }) {
  if (!isEnabled) {
    return null;
  }

  return (
    <AdminPage>
      <IntegrationsNav>
        <WebhooksList />
      </IntegrationsNav>
    </AdminPage>
  );
}

WebhooksAdminPage.propTypes = {
  isEnabled: PropTypes.bool.isRequired,
};

export default connect(mapStateToProps)(WebhooksAdminPage);

function mapStateToProps({ getProvider, isFeatureEnabled }) {
  return {
    isEnabled: isFeatureEnabled('devManagement'),
  };
}



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/admin/integrations/webhooks_admin_page.jsx